import { render } from "./CoBrandTerracotta.vue?vue&type=template&id=51d60331&scoped=true"
import script from "./CoBrandTerracotta.vue?vue&type=script&lang=js"
export * from "./CoBrandTerracotta.vue?vue&type=script&lang=js"

import "./CoBrandTerracotta.vue?vue&type=style&index=0&id=51d60331&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d60331"]])

export default __exports__